import { createSlice } from '@reduxjs/toolkit';
import { ProductSetDetailStateType } from 'src/types/productSetDetail';
import getErrorKeys from 'src/utils/getErrorKeys';

const initialState: ProductSetDetailStateType = {
    data: null,
    loading: false,
    deleted: false,
    error: false,
    apiErrorKeys: null,
};
export const productSetDetailSlice = createSlice({
    name: 'productSetDetail',
    initialState,
    reducers: {
        getProductSetDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        getProductSetDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        getProductSetDetailFetchFailure: (state, action) => {
            state.data = null;
            state.loading = false;
            state.error = true;
        },
        createProductSetDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
            state.apiErrorKeys = null;
        },
        createProductSetDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        createProductSetDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
            state.apiErrorKeys = getErrorKeys(action.payload);
        },
        updateProductSetDetailFetch: (state, action) => {
            state.loading = true;
            state.error = false;
            state.apiErrorKeys = null;
        },
        updateProductSetDetailFetchSuccess: (state, action) => {
            state.data = action.payload.data;
            state.loading = false;
        },
        updateProductSetDetailFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
            state.apiErrorKeys = getErrorKeys(action.payload);
        },
        deleteProductSetFetch: (state, action) => {
            state.loading = true;
            state.error = false;
        },
        deleteProductSetFetchSuccess: (state, action) => {
            state.deleted = true;
            state.loading = false;
        },
        deleteProductSetFetchFailure: (state, action) => {
            // state.data = null;
            state.loading = false;
            state.error = true;
        },
        clearProductSetDetail: () => initialState,
    },
});

export const {
    getProductSetDetailFetch,
    getProductSetDetailFetchSuccess,
    getProductSetDetailFetchFailure,
    createProductSetDetailFetch,
    createProductSetDetailFetchSuccess,
    createProductSetDetailFetchFailure,
    updateProductSetDetailFetch,
    updateProductSetDetailFetchSuccess,
    updateProductSetDetailFetchFailure,
    deleteProductSetFetch,
    deleteProductSetFetchSuccess,
    deleteProductSetFetchFailure,
    clearProductSetDetail,
} = productSetDetailSlice.actions;

export default productSetDetailSlice.reducer;
